if ( typeof SplitScreenSlider !== 'function' ) {

  class SplitScreenSlider extends HTMLElement {

    constructor(){
      super();

      this.mount();
      this.RESIZE_SliderHelper = debounce(()=>{
        this.unmount();
        this.mount();
      }, 300);
      window.addEventListener('resize', this.RESIZE_SliderHelper, { passive:true });
    }

    mount(){

      this._currentScroll = window.scrollY;
      this._headerHeight = document.getElementById('site-header') ? document.getElementById('site-header').offsetHeight : 0;

      this._fullWidth = this.classList.contains('layout-full') ? true : false;
      this._scrollEnabled = true;

      this._screenHeight = Math.min(window.innerHeight, window.screen.availHeight);

      this.slides = this.querySelectorAll('.slider-item');
      this.slidesMedia = this.querySelectorAll('.slider-item-media > div');
      this.slidesBlackArray = this.querySelectorAll('.slider-item-media-overlay');
      this.headings = this.querySelectorAll('.box__heading');

      // ✅ WICHTIG: erstes Bild immer initial sichtbar machen
      this._forceFirstSlideVisible();

      // Bestehende Initial-Logik beibehalten, aber ohne first-slide zu “killen”
      this.slides.forEach((elm, key)=>{
        if (!this.slidesMedia[key]) return;

        if ( key === 0 || window.scrollY >= this._getOffsetTop(elm) ) {
          // first slide bleibt sichtbar (layout-full wird über _forceFirstSlideVisible geregelt)
          if (!this._fullWidth || key !== 0) {
            this.slidesMedia[key].style.height = `100%`;
          }
        } else {
          this.slidesMedia[key].style.height = `0`;
        }
      });

      const cssSlider = this.querySelector('css-slider');

      if (cssSlider) {
        cssSlider.addEventListener('ready', ()=>{
          const cssSliderSlides = this.querySelectorAll('.slider-item');
          const cssSlidesMediaElements = this.querySelectorAll('.slider-item-media-element');
          cssSlider.addEventListener('scroll', ()=>{
            const scrollX = -cssSlider.element.scrollLeft;
            cssSliderSlides.forEach((slide,i)=>{
              const media = cssSlidesMediaElements[i];
              if ( media ) {
                media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
              }
            });
          });
        });
      }

      let previous = -1,
          currentOld = -1;

      this.SCROLL_SliderHelper = () => {

        const scrollTop = window.scrollY >= 0 ? window.scrollY : 0;
        const sliderTop = this._getOffsetTop(this);
        const sliderBottom = sliderTop + this.offsetHeight;

        // ✅ Wenn wir OBERHALB des Sliders sind: erstes Bild muss sichtbar sein (sonst “weiß”)
if (scrollTop + this._headerHeight < sliderTop) {
  // back-to-normal darf sein, aber NICHT returnen -> damit der Slider-State sauber bleibt
  if (!this.classList.contains('back-to-normal')) {
    this.classList.add('back-to-normal');
  }
  this._forceFirstSlideVisible();
}

        // ✅ Wenn wir UNTERHALB des Sliders sind: nicht “weiß” werden beim Zurückscrollen
        // (wir lassen die Logik normal laufen, aber first bleibt abgesichert)
        if (scrollTop > sliderBottom) {
          // optional: first slide sichtbar halten (damit beim “wieder rein” kein flash)
          this._forceFirstSlideVisible();
        }

        if ( this._scrollEnabled ) {

          let current = 0;

          if ( scrollTop + this._headerHeight - this._headerHeight < this._getOffsetTop(this) && ! this.classList.contains('back-to-normal') ) {
            this.classList.add('back-to-normal');
          }

          this.slides.forEach((elm, key)=>{
            if ( this._checkVisible(elm) ) {
              current = key;
            }
          });

          // ✅ Sicherheit: wenn current==0, erstes Bild immer sichtbar halten
          if (current === 0) {
            this._forceFirstSlideVisible();
          }

          if ( current != currentOld ) {
            if ( this._currentScroll < scrollTop && currentOld > 0 ) {
              this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], this._screenHeight );
            } else if ( this._currentScroll > window.scrollY && currentOld > 0 ) {
              this._scrollMedia( current, this.slides[currentOld], this.slides[previous], this.slidesMedia[currentOld], this.slidesBlackArray[previous], 0 );
            }
            currentOld = current;
            previous = current - 1;
          }

          if ( current == 0 && scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
            this.classList.add('back-to-normal');
          } else if ( current > 0 ) {

            const scrollValue = ( scrollTop - sliderTop ) - this._screenHeight * ( current - 1 );

            if ( ! this.classList.contains('back-to-normal') ) {
              this._scrollMedia( current, this.slides[current], this.slides[previous], this.slidesMedia[current], this.slidesBlackArray[previous], scrollValue );
            }

            if ( scrollTop + this._screenHeight >= sliderTop + this.offsetHeight && ! this.classList.contains('back-to-normal') ) {
              this.classList.add('back-to-normal');
            } else if ( scrollTop + this._screenHeight < sliderTop + this.offsetHeight && this.classList.contains('back-to-normal' ) ) {
              this.classList.remove('back-to-normal');
            }
          }
        }

        this._currentScroll = scrollTop;
      }

      window.addEventListener('scroll', this.SCROLL_SliderHelper, { passive:true });
      this.SCROLL_SliderHelper();
    }

    unmount() {
      window.removeEventListener('scroll', this.SCROLL_SliderHelper);
    }

    // ✅ NEU: erstes Bild IMMER sichtbar erzwingen
    _forceFirstSlideVisible(){
      if (!this.slidesMedia || !this.slidesMedia[0]) return;

      if (this._fullWidth) {
        // layout-full nutzt clip-path -> muss “voll offen” sein
        this.slidesMedia[0].style.height = `100%`;
        this.slidesMedia[0].style.clipPath = `polygon(0 0, 100% 0, 100% 100%, 0% 100%)`;
        this.slidesMedia[0].style.transform = `none`;
      } else {
        // layout-split nutzt height
        this.slidesMedia[0].style.height = `100%`;
      }

      // overlay vom vorherigen ggf. zurücksetzen
      if (this.slidesBlackArray && this.slidesBlackArray[0]) {
        this.slidesBlackArray[0].style.opacity = `0`;
      }
    }

    _scrollMedia(index, currentSlide, previousSlide, currentSlideMedia, previousSlideOverlay, scrollValue) {

      // ✅ Wenn index==0: niemals “zu” clippen / niemals 0 setzen
      if (index === 0) {
        this._forceFirstSlideVisible();
        return;
      }

      if ( this._fullWidth ) {
        currentSlideMedia.style.clipPath = `polygon(0 ${window.innerHeight - scrollValue + 1}px, 100% ${window.innerHeight - scrollValue + 1}px, 100% 100%, 0% 100%)`;
      } else {
        currentSlideMedia.style.height = `${scrollValue}px`;
      }

      if ( previousSlideOverlay ) {
        previousSlideOverlay.style.opacity = `${Math.ceil( scrollValue * 30 / this._screenHeight ) / 100}`;
      }
    }

    _checkVisible(elm) {
      const rect = elm.getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }

    _getOffsetTop(elm) {
      if (!elm.getClientRects().length) {
        return 0;
      }
      const rect = elm.getBoundingClientRect();
      const win = elm.ownerDocument.defaultView;
      return rect.top + win.pageYOffset;
    }
  }

  if ( typeof customElements.get('split-screen-slider') == 'undefined' ) {
    customElements.define('split-screen-slider', SplitScreenSlider);
  }
}